var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-header',{on:{"searchNav":_vm.searchApp}}),_c('keep-alive',[_c('router-view',{ref:"navBox",staticStyle:{"min-height":"77vh"}})],1),_c('nav-bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }